/**
 * Konkord: the token of a Stoat confirmation link (`…/login/verify/<token>`),
 * pasted on our site so the account is confirmed (and signed in) here instead
 * of on Stoat's site
 */
export function verifyTokenFrom(text: string) {
  const match = text.trim().match(/\/login\/verify\/([A-Za-z0-9_-]{8,128})(?:[/?#]|$)/);
  return match?.[1];
}
